// import { useEffect } from 'react';

const Modal = ({ children, title, onSuccess, showModal, closeModal, hideCancelBtn, minHeight = null, successBtnText = 'Ok', cancelBtnText = 'Cancel' }) => {
  // useEffect(() => {
  //   if (showModal) {
  //     document.documentElement.style.overflow = 'hidden';
  //   } else {
  //     document.documentElement.style.overflow = 'unset';
  //   }
  //   return () => document.documentElement.style.overflow = 'unset';
  // }, [showModal]);

  if (!showModal) return null;

  return (
    <div className="modal is-active">
      <div className="modal-background" onClick={closeModal}></div>
        <div className="modal-card">
          {title && (
            <header className="modal-card-head">
              <p className="modal-card-title">{title}</p>
              {closeModal && <button className="delete" aria-label="close" onClick={closeModal}></button>}
            </header>
          )}
        <section className="modal-card-body">
          {children}
        </section>
        {onSuccess && (
          <footer className="modal-card-foot">
            <button className="button is-success" onClick={onSuccess}>{successBtnText}</button>
            {!hideCancelBtn && <button className="button" onClick={closeModal}>{cancelBtnText}</button>}
          </footer>
        )}
      </div>

      {closeModal && <button className="modal-close is-large" aria-label="close" onClick={closeModal}></button>}
    </div>
  );
};

const SimpleModal = ({ children, closeModal, showModal, isWhiteBackground }) => {
  if (!showModal) return null;

  return (
    <div className="modal is-active">
      <div
        className="modal-background"
        style={{backgroundColor: isWhiteBackground ? 'white' : null}}
        onClick={closeModal}>
      </div>

      <div className="modal-content" style={{width: '100%'}}>
        <section className="section">
          {children}
        </section>
      </div>

      <button
        className="modal-close is-large"
        style={{backgroundColor: isWhiteBackground ? 'black' : null}}
        aria-label="close"
        onClick={closeModal}>
      </button>
    </div>
  );
}

export default Modal;

export {
  SimpleModal,
  Modal
};
